import ProjectHeaderLocalSettings from "../../../local-settings"
import {BUS_TOGGLE_SUBMENU} from "../../../../../../../core/gd/bus/bus-event-type"

export default function header_toggleIsCompact(projectId: ID) {
    const localSettings = new ProjectHeaderLocalSettings()

    const newValue = !localSettings.isSubmenuCompact(projectId)
    localSettings.setSubmenuCompact(projectId, newValue)
    localSettings.save()

    gd.bus.triggerEvent(BUS_TOGGLE_SUBMENU)

    return localSettings
}